module.exports = __webpack_public_path__ + "static/media/chip.80fa62d4.svg";